import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useHistory } from "react-router-dom";
import avatar from "./../avatar.png";
import "./Header.css";

const Header = ({ children, hasHiddenAuthButtons }) => {
  let history = useHistory();
  return (
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon" />
      </Box>
      {children}
      {hasHiddenAuthButtons && localStorage.getItem("token") !== null ? (
        <Stack direction="row" spacing={1}>
          <Avatar src={avatar} alt={localStorage.getItem("username")} />
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {localStorage.getItem("username")}
          </p>
          <Button
            onClick={() => {
              localStorage.clear();
              window.location.reload();
            }}
          >
            Logout
          </Button>
        </Stack>
      ) : hasHiddenAuthButtons && localStorage.getItem("token") === null ? (
        <Stack direction="row" spacing={1}>
          <Button onClick={() => history.push("/login")}>Login</Button>
          <Button variant="contained" onClick={() => history.push("/register")}>
            Register
          </Button>
        </Stack>
      ) : (
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={() => history.push("/")}
        >
          Back to explore
        </Button>
      )}
    </Box>
  );
};

export default Header;
